const freeStyleLogo = require("@/assets/images/freedefine.png");
const proposalLogo = require("@/assets/images/proposal.png");
const serviceOfferingLogo = require("@/assets/images/servicesoffering.png");
const softwareComponentLogo = require("@/assets/images/softwarecomponent.png");
const standardSolutionLogo = require("@/assets/images/standardsolutions.png");
const technicalKnowledgeLogo = require("@/assets/images/knowhow.png");

export const ipType = [
    {
      id: 1,
      name: "Tự động hóa",
      code: "automation",
      thumb: softwareComponentLogo,
      href: `#`,
      description:
        "Sử dụng nhiều hệ thống điều khiển cho các thiết bị hoạt động/công cụ làm việc, đồng thời tự động các quy trình làm việc của con người nhằm tiết kiệm thời gian, nguồn lực, chi phí đồng thời có tính chính xác cao và hiệu quả mang lại lớn.\nNhư nền tảng DevOps, giải pháp RPA,…"
    },
    {
      id: 2,
      name: "Công cụ/thiết bị làm việc",
      code: "equipment",
      thumb: serviceOfferingLogo,
      href: "#",
      description:
        "Là đồ dùng để lao động, sản xuất nhằm hoàn thành chính công việc của cá nhân hay tập thể.\nVí dụ: Máy hàn pin; Thiết bị ra cáp; Quyển sổ tư vấn truyền hình…."
    },
    {
      id: 3,
      name: "Cải tiến quy trình",
      code: "process_improvement",
      thumb: proposalLogo,
      href: "#",
      description: "Thay đổi/Rút gọn các bước làm việc để giúp công việc của con người tốt hơn.\nVí dụ: Quy trình phân cấp, phân quyền,…."
    },
    {
      id: 4,
      name: "Cải tiến sản phẩm, dịch vụ",
      code: "improving_products_and_services",
      thumb: technicalKnowledgeLogo,
      href: "#",
      description: "Thay đổi tính năng, hạng mục cấu thành nên sản phẩm, dịch vụ nhằm tăng trải nghiệm và độ hài long cho nhân viên, khách hàng.\nVí dụ: Tính năng mặt cười, mặt mếu ở nhà vệ sinh – FE;"
    },
    {
      id: 5,
      name: "Sản phẩm phát triển văn hóa FPT",
      code: "cultural",
      thumb: freeStyleLogo,
      href: "#",
      description: "Là các sản phẩm nhằm lưu trữ, phát huy và phát triển các hoạt động văn hóa, đoàn thể của FPT.\nVí dụ: Bảo tàng FPT,…"
    },
    {
      id: 6,
      name: "Các loại hình sáng tạo khác",
      code: "other",
      thumb: standardSolutionLogo,
      href: "#",
      description: "Là các hoạt động tạo ra các sản phẩm có tính mới và tính lợi ích, không nằm trong các phạm vi được liệt kê trên."
  },
    {
      id: 7,
      name: "Tool/ phần mềm",
      code: "software",
      thumb: standardSolutionLogo,
      href: "#",
      description: "Là công cụ phát triển dựa trên nền tảng công nghệ giúp cho quá trình làm việc hiệu quả hơn rất nhiều, tăng năng suất lao động đáng kể và tiết kiệm được rất nhiều thời gian, chi phí của doanh nghiệp.\nVí dụ: Tool Mail Merge; Uservices;…."
    }
  ]



// WEBPACK FOOTER //
// ./src/components/const/ipType.js